import { UserAgent } from "@quentin-sommer/react-useragent";
import { useLoaderData } from "@remix-run/react";
import Desktop from "./Desktop";
import Mobile from "./Mobile";

function ServicesServiceScreen(props) {
  const { providers } = useLoaderData();
  const { textQuery, sortFilter, products } = props;

  const productsMappedWithProviders: Array<{
    provider: any;
    products: any[];
  }> = [];

  providers?.results?.forEach((provider) => {
    const filteredProducts = products?.results
      ?.filter((p) => p._provider.name.common === provider.name.common)
      ?.filter(
        (p) =>
          !!p?._country?.name.common
            ?.toLowerCase()
            .includes(textQuery?.toLowerCase()) ||
          !!p?._country?.name.a2
            ?.toLowerCase()
            .includes(textQuery?.toLowerCase()),
      )
      .sort((a, b) => {
        if (sortFilter === "price-low-to-high") return a.price - b.price;
        if (sortFilter === "price-high-to-low") return b.price - a.price;
        if (sortFilter === "quality-low-to-high") {
          if (!a.inventory?.quantity) return -1;
          if (!b.inventory?.quantity) return 1;
          return a.inventory?.quality - b.inventory?.quality;
        }
        if (sortFilter === "quality-high-to-low") {
          if (!a.inventory?.quantity) return 1;
          if (!b.inventory?.quantity) return -1;
          return b.inventory?.quality - a.inventory?.quality;
        }
        return 0;
      });

    if (filteredProducts.length < 1) return;

    productsMappedWithProviders.push({
      provider,
      products: filteredProducts,
    });
  });

  return (
    <section>
      <UserAgent computer>
        <Desktop
          {...props}
          productsMappedWithProviders={productsMappedWithProviders}
        />
      </UserAgent>

      <UserAgent tablet>
        <Desktop
          {...props}
          productsMappedWithProviders={productsMappedWithProviders}
        />
      </UserAgent>

      <UserAgent mobile>
        <Mobile
          {...props}
          productsMappedWithProviders={productsMappedWithProviders}
        />
      </UserAgent>
    </section>
  );
}

export default ServicesServiceScreen;
